import { AppRoutesEnum } from '../enums/app-routes.enum';
import { DataServices } from '../enums/data-services.enum';
import { InvestigatorServiceActions } from '../enums/service-actions/investigator-service-actions.enum';
import { AccessType } from '../enums/access-type.enum';
import { AccessServiceActions } from '../enums/service-actions/access-service-actions.enum';
import { OrganizationServiceActions } from '../enums/service-actions/organization-service-actions.enum';
import { PoliciesServiceActions } from '../enums/service-actions/policies-service-actions.enum';

export const routePermissions = {
  [AppRoutesEnum.InvestigationsOverall]: [
    `${DataServices.Investigator}.${InvestigatorServiceActions.Search}.${AccessType.Read}`,
    `${DataServices.Investigator}.${InvestigatorServiceActions.Columns}.${AccessType.Read}`,
    `${DataServices.Investigator}.${InvestigatorServiceActions.Layouts}.${AccessType.Read}`,
    `${DataServices.Investigator}.${InvestigatorServiceActions.Queries}.${AccessType.Read}`,
  ],
  [AppRoutesEnum.InvestigationsEntity]: [
    `${DataServices.Investigator}.${InvestigatorServiceActions.Graphs}.${AccessType.Read}`,
  ],
  [AppRoutesEnum.UsersManagement]: [
    `${DataServices.Access}.${AccessServiceActions.Users}.${AccessType.Read}`,
  ],
  [AppRoutesEnum.UsersManagementUsers]: [
    `${DataServices.Access}.${AccessServiceActions.Users}.${AccessType.Read}`,
  ],
  [AppRoutesEnum.UsersManagementRoles]: [
    `${DataServices.Access}.${AccessServiceActions.Roles}.${AccessType.Read}`,
  ],
  [AppRoutesEnum.UsersManagementRolesWrite]: [
    `${DataServices.Access}.${AccessServiceActions.Roles}.${AccessType.Write}`,
  ],
  [AppRoutesEnum.Organization]: [
    `${DataServices.Organizations}.${OrganizationServiceActions.Organizations}.${AccessType.Read}`,
  ],
  [AppRoutesEnum.PolicySettingsAlerts]: [],
  [AppRoutesEnum.PolicySettingsLists]: [
    `${DataServices.Policies}.${PoliciesServiceActions.Lists}.${AccessType.Read}`,
  ],
  [AppRoutesEnum.PolicySettingsPolicies]: [
    `${DataServices.Policies}.${PoliciesServiceActions.Policies}.${AccessType.Read}`,
  ],
};
